import React, { useState } from "react";
import { motion } from "framer-motion";
import "./exam.scss"; // Import SCSS

interface StarRatingProps {
  totalStars?: number;
  onRatingSelect: (rating: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({ totalStars = 5, onRatingSelect }) => {
  const [selectedStars, setSelectedStars] = useState<number>(0);
  const [hoveredStars, setHoveredStars] = useState<number>(0);

  const handleClick = (rating: number) => {
    setSelectedStars(rating);
    onRatingSelect(rating);
  };

  return (
    <div className="star-container">
      {Array.from({ length: totalStars }, (_, index) => {
        const starValue = index + 1;
        return (
          <motion.i
            key={starValue}
            onClick={() => handleClick(starValue)}
            onMouseEnter={() => setHoveredStars(starValue)}
            onMouseLeave={() => setHoveredStars(0)}
            className={`star ${starValue <= (hoveredStars || selectedStars) ? "filled" : ""}`}
            whileHover={{ scale: 1.2 }}
            // whileTap={{ scale: 0.9, rotate: [0, -10, 10, 0] }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            ★
          </motion.i>
        );
      })}
    </div>
  );
};

export default StarRating;
